import {
  Button,
  Input,
  Stack,
  Typography,
  Menu,
  MenuItem,
} from "@mui/material";
import MenuDateReports from "../atomic/MenuDateReports";
const HeaderMenuDates = ({ setOpenDialog, setBodyDialog, setDatos, setTitle }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={5}
    >
      <Typography variant="h4" gutterBottom>
        Reportes analíticos por fechas (General)
      </Typography>
      <MenuDateReports
        setDatos={setDatos}
        setOpenDialog={setOpenDialog}
        setBodyDialog={setBodyDialog}
        setTitle={setTitle}
      />
    </Stack>
  );
};

export default HeaderMenuDates;
